import _ from "lodash";
import initialState from "./initialState";
import types from "../actions/actionTypes";
import environments from "../../common/environments";
export default function environmentReducer(state, action) {
	switch (action.type) {
		case types.ENVIRONMENT.SET:
			window.cpAdmin = {
				ssoUrl: action.info.ssoUrl,
				cpUrl: action.info.provisioningUrl,
				aggregatorUrl: action.info.aggregatorUrl,
				connectedSupportedDevices: _.get(action, `info.connectedSupportedDevices`)
			};
			return {
				version: _.get(action, `info.version`, `NO VERSION FOUND`),
				environment: getEnvironmentTranslation(_.get(action, `info.environment`)),
				customerOriginMatcher: _.get(action, `info.customerOriginMatcher`),
				priorityCountries: _.get(action, `info.priorityCountries`),
				oidc: _.get(action, `info.oidc`)
			};
		default:
			return state || initialState.loadInitials().environment;
	}
}

function getEnvironmentTranslation(environment) {
	switch (environment) {
		case environments.LOCAL.KEY:
			return environments.LOCAL.VALUE;
		case environments.DEVELOPMENT.KEY:
			return environments.DEVELOPMENT.VALUE;
		case environments.ACCEPTANCE.KEY:
			return environments.ACCEPTANCE.VALUE;
		case environments.PREVIEW.KEY:
			return environments.PREVIEW.VALUE;
		case environments.PRODUCTION.KEY:
			return environments.PRODUCTION.VALUE;
		default:
			return environments.NOT_FOUND;
	}
}
